import { render } from "./EditAct.vue?vue&type=template&id=978e538c"
import script from "./EditAct.vue?vue&type=script&lang=js"
export * from "./EditAct.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__